import React from 'react';

import AddEmailAddressStep2 from './AddEmailAddressStep2';
import { EmailAddress } from 'src/models/Email/EmailAddress';
import EmbedModalWithGreenHeader from 'src/presentation/components/pages/shared/EmbedModalWithGreenHeader';
import { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';

type ViewForwardingEmailAddressModalType = {
  handleCloseModal: () => void;
  emailAddress: EmailAddress;
};

export default function ViewForwardingEmailAddressModal({
  handleCloseModal,
  emailAddress,
}: ViewForwardingEmailAddressModalType) {
  const getModalContent = () => <AddEmailAddressStep2 value={emailAddress} onDone={handleCloseModal} />;

  return (
    <EmbedModalWithGreenHeader
      data-aid="new-email-address"
      title="View forwarding address"
      disableOutsideClick={true}
      modalSize={ModalSize.EXTRALARGE}
      content={getModalContent()}
      onCancel={handleCloseModal}
    />
  );
}
